import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api';
import { Alert, AlertDescription } from '../ui/alert';
import { Button } from '../ui/button';
import { Flame } from 'lucide-react';

/**
 * StreakReminderBanner
 *
 * Gentle, dismissible nudge shown on the talent dashboard when their Digital
 * Business Card sharing streak is at risk — they have an active streak but
 * haven't shared yet today. Mirrors the weekly email nudge, in-app.
 */
const StreakReminderBanner = () => {
  const navigate = useNavigate();
  const [atRisk, setAtRisk] = useState(false);
  const [streak, setStreak] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let active = true;
    api
      .get('/talent/card/stats')
      .then((r) => {
        if (!active) return;
        const s = r.data || {};
        const days = Number(s.share_streak_days || 0);
        if (days >= 1 && s.shared_today === false) {
          setStreak(days);
          setAtRisk(true);
        }
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  if (!atRisk || dismissed) return null;

  return (
    <Alert
      className="mb-6 bg-gradient-to-r from-cyan-50 to-teal-50 border-cyan-300"
      data-testid="streak-reminder-banner"
    >
      <div className="flex items-start gap-3">
        <Flame className="h-5 w-5 text-orange-500 shrink-0 mt-0.5" />
        <div className="flex-1">
          <AlertDescription className="text-cyan-900">
            You're on a <strong>{streak}-day sharing streak</strong>. Share your
            card today to keep it alive and stay in front of more clients.
          </AlertDescription>
          <div className="mt-3 flex items-center gap-2">
            <Button
              size="sm"
              className="bg-cyan-600 hover:bg-cyan-700 text-white"
              onClick={() => navigate('/talent/my-card')}
              data-testid="streak-share-now-btn"
            >
              Share my card
            </Button>
            <Button
              size="sm"
              variant="ghost"
              className="text-cyan-700"
              onClick={() => setDismissed(true)}
              data-testid="streak-dismiss-btn"
            >
              Maybe later
            </Button>
          </div>
        </div>
      </div>
    </Alert>
  );
};

export default StreakReminderBanner;
